import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Mic, MessageCircle, Search, User, Grid, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/services", label: "Services", Icon: Grid },
  { to: "/services/receptionniste-ia", label: "Réceptionniste Vocal IA", Icon: Mic },
  { to: "/services/whatsapp-ia", label: "Assistant WhatsApp IA", Icon: MessageCircle },
  { to: "/audit-ia", label: "Audit gratuit", Icon: Search },
  { to: "/a-propos", label: "À propos", Icon: User },
];

const desktopLinks = [
  { to: "/services/receptionniste-ia", label: "Réceptionniste Vocal IA" },
  { to: "/services/whatsapp-ia", label: "Assistant WhatsApp IA" },
  { to: "/audit-ia", label: "Audit gratuit" },
  { to: "/a-propos", label: "À propos" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <nav
        data-testid="main-nav"
        className="sticky top-0 z-50 bg-white/85 backdrop-blur-md border-b border-slate-200/70"
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <Logo />
          <div className="hidden md:flex items-center gap-6">
            {desktopLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                data-testid={`nav-link-${to.replace(/\//g, "-").replace(/^-/, "")}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  pathname === to ? "text-[#3ecf8e]" : "text-slate-600 hover:text-[#1a2744]"
                }`}
              >
                {label}
              </Link>
            ))}
            <Link to="/contact" className="btn-primary !py-3 !px-5 !text-sm" data-testid="nav-cta-contact">
              Prendre contact <ArrowRight size={16} />
            </Link>
          </div>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            data-testid="nav-hamburger"
            className="md:hidden w-11 h-11 rounded-full bg-[#1a2744] text-white flex items-center justify-center"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="fixed inset-0 z-40 bg-white pt-24 px-6 md:hidden overflow-y-auto"
        >
          <div className="flex flex-col gap-2">
            {links.map(({ to, label, Icon }) => (
              <Link
                key={to}
                to={to}
                data-testid={`mobile-link-${to.replace(/\//g, "-").replace(/^-/, "")}`}
                className="flex items-center gap-4 py-4 border-b border-slate-100"
              >
                <span className="icon-square !w-11 !h-11 !rounded-xl">
                  <Icon size={20} />
                </span>
                <span className="title-text font-semibold">{label}</span>
              </Link>
            ))}
            <Link to="/contact" className="btn-primary mt-6" data-testid="mobile-cta-contact">
              Prendre contact <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
